/* Stampify · sito nuovo. Tutto il comportamento delle pagine.
   La pagina passa i dati in window.SY (lingua, prezzi, testi, variante della landing). */
(function () {
  'use strict';
  var SY = window.SY || {};
  var L = SY.lang || 'it';
  var T = SY.t || {};
  /* "7–12" non va a capo dopo il trattino (U+2060 invisibile; add() lo toglie dalla nota dell'ordine) */
  ['preShip'].forEach(function (k) { if (T[k]) T[k] = String(T[k]).replace(/(\d)\u2013(?=\d)/g, '$1\u2013\u2060') });
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || SY.root || '/';
  var WA = SY.wa || '393922770046';
  var doc = document.documentElement;
  function $(s, r) { return (r || document).querySelector(s) }
  function $$(s, r) { return [].slice.call((r || document).querySelectorAll(s)) }
  function mm(q) { return window.matchMedia && matchMedia(q).matches }
  var reduce = mm('(prefers-reduced-motion: reduce)');
  /* 01/10 (Danilo: "header bloccalo subito e blocca fisso in basso anche il banner"): sui telefoni la pagina scorre dentro il body e l'html sta fermo
     (sito.css). Safari e i browser dentro Instagram/Facebook ritirano le loro barre solo quando scorre il documento: così non le ritirano mai,
     lo schermo non cambia misura e testata e barra restano inchiodate (su iOS 26 il ritiro della toolbar spostava fixed e sticky, bug WebKit 297779).
     SC è chi scorre; sY, sTo e onScr valgono per finestra e body. La stessa media query sta in sito.css e nello script della home. */
  var SC = mm('(hover: none) and (pointer: coarse)') ? document.body : window;
  function sY() { return SC === window ? window.scrollY : SC.scrollTop }
  function sTo(o) { SC.scrollTo(o) }
  function onScr(fn) { SC.addEventListener('scroll', fn, { passive: true }) }
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  function store(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, String(v));
    } catch (e) { return null }
  }
  function money(cents) {
    var n = Math.round(cents) / 100, dec = Math.round(cents) % 100 !== 0;
    var o = { minimumFractionDigits: dec ? 2 : 0, maximumFractionDigits: 2 };
    /* stesso formato di money() nel generatore e di sn-soldi.liquid */
    if (L === 'en') return '€' + n.toLocaleString('en-IE', o);
    var t = n.toLocaleString('de-DE', o);  /* punto per le migliaia, virgola per i decimali */
    if (L === 'de' || L === 'fr' || L === 'es' || L === 'pl' || L === 'pt') return t + '\u00a0€';
    if (L === 'nl') return '€\u00a0' + t;
    return '€' + t;
  }
  function escH(x) { return String(x == null ? '' : x).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') }
  function fmt(s, o) { return String(s || '').replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : '' }) }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms) } }
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- comparsa ---------- */
  if (hasIO) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('vis'); io.unobserve(e.target) } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6%' });
    $$('.r').forEach(function (el) {
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  } else $$('.r').forEach(function (el) { el.classList.add('vis') });

  /* ---------- timer dell'offerta di lancio: conta fino alla data vera, poi sparisce ---------- */
  var promo = $('#promo');
  if (promo) {
    var end = Date.parse(promo.dataset.end), U = {};
    $$('[data-u]', promo).forEach(function (e) { U[e.dataset.u] = e });
    var two = function (n) { return (n < 10 ? '0' : '') + n };
    (function tickPromo() {
      var ms = end - Date.now();
      if (!(ms > 0)) { promo.hidden = true; doc.classList.remove('has-promo'); return }
      var s = Math.floor(ms / 1000);
      U.d.textContent = Math.floor(s / 86400);
      U.h.textContent = two(Math.floor(s % 86400 / 3600));
      U.m.textContent = two(Math.floor(s % 3600 / 60));
      U.s.textContent = two(s % 60);
      setTimeout(tickPromo, 1000 - (Date.now() % 1000) + 5);
    })();
  }

  /* ---------- barra in alto e menu ---------- */
  var nav = $('.nav'), hero = $('.hero');
  function navState() {
    if (!nav) return;
    var lim = 10; /* fondo chiaro: la barra diventa piena appena si scorre, così il logo non passa sopra il video */
    nav.classList.toggle('solid', sY() > lim);
  }
  onScr(navState); navState();
  /* il tasto WhatsApp compare solo dopo il primo schermo, per non coprire titolo e garanzie */
  var firstBlock = hero || $('.ph');
  if (firstBlock && hasIO) new IntersectionObserver(function (es) { doc.classList.toggle('past-hero', !es[0].isIntersecting) }, { rootMargin: '-40% 0px 0px 0px' }).observe(firstBlock);
  else doc.classList.add('past-hero');
  var burger = $('.nav-burger'), drawer = $('#drawer');
  function menu(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    doc.classList.toggle('lock', open);
    nav.classList.toggle('menu', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
  }
  if (burger && drawer) {
    burger.addEventListener('click', function () { menu(!drawer.classList.contains('open')) });
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { menu(false) }) });
  }

  /* ---------- video ---------- */
  function wide() { return mm('(min-width: 900px) and (min-aspect-ratio: 1/1)') }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}) }
  $$('video[data-m]').forEach(function (v) {
    if (reduce || saveData) return;
    function pick() {
      var s = wide() && v.dataset.d ? v.dataset.d : v.dataset.m;
      if (v.dataset.cur === s) return;
      v.dataset.cur = s; v.classList.remove('playing'); v.src = s; v.load(); play(v);
    }
    v.addEventListener('playing', function () { v.classList.add('playing') });
    pick(); addEventListener('resize', debounce(pick, 300));
    if (hasIO) new IntersectionObserver(function (es) { es[0].isIntersecting ? play(v) : v.pause() }).observe(v);
  });
  if (hasIO) {
    var vio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (!v.getAttribute('src')) { v.src = v.dataset.src } play(v) }
        else if (v.getAttribute('src')) v.pause();
      });
    }, { rootMargin: '250px 0px' });
    $$('video[data-src]').forEach(function (v) { if (!reduce && !saveData) vio.observe(v) });
  }
  /* pallini sotto i passaggi scorrevoli */
  $$('.steps').forEach(function (s) {
    var dots = s.parentNode.querySelectorAll('.steps-hint i');
    if (!dots.length) return;
    s.addEventListener('scroll', debounce(function () {
      var w = s.firstElementChild.getBoundingClientRect().width || 1;
      var i = Math.round(s.scrollLeft / (w + 12));
      [].forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i) });
    }, 60), { passive: true });
  });

  /* ---------- scelta del prodotto ---------- */
  var P = SY.products || [], PACKS = SY.packs || [];
  /* scorte: sul negozio le passa il tema da Shopify (window.SY_STOCK, per id variante), in anteprima stanno in SY.stock.
     Un prodotto esaurito non si può scegliere e il tasto Aggiungi resta spento. */
  (function () {
    var live = window.SY_STOCK, base = SY.stock || {};
    P.forEach(function (p) {
      var v = live && live[p.id];
      if (v) { p.outShop = !v.ok; p.pre = !!v.pre; p.left = v.n != null && v.n > 0 ? v.n : null; }
      else { p.outShop = (base.out || []).indexOf(p.k) >= 0; p.pre = (base.pre || []).indexOf(p.k) >= 0; p.left = (base.left || {})[p.k] || null; }
      p.out = p.outShop;
      p.tot = ((SY.lotto || {}).tot || {})[p.k] || null;  /* pezzi del lotto: la barra del contatore parte da qui */
    });
  })();
  /* "Prenota" quando nessuna misura si compra subito ma almeno una si prenota. Dalle scorte vere del negozio
     (window.SY_STOCK, in ogni pagina del layout), così vale anche su contatti, rivenditori, 404 e catalogo */
  function soloPre() {
    var live = window.SY_STOCK, v = live ? Object.keys(live).map(function (k) { return live[k] }).map(function (x) { return { ok: !!x.ok, pre: !!x.pre } })
      : P.map(function (p) { return { ok: !p.out, pre: !!p.pre } });
    return v.some(function (x) { return x.ok && x.pre }) && !v.some(function (x) { return x.ok && !x.pre });
  }
  function buyLabels() { var sp = soloPre(); $$('.js-buylbl').forEach(function (e) { e.textContent = sp ? T.preCta : e.dataset.base }) }
  /* ---------- lotto: pezzi rimasti dal vivo e riserva di 10 minuti (25/09) ----------
     Il contatore mostra le scorte vere di Shopify. Chi aggiunge al carrello vede subito il suo pezzo tolto dal conteggio
     per RISERVA minuti (sy_res in localStorage, per variante), con il tempo che scorre; a tempo scaduto il pezzo torna
     nel conteggio e si dice che è ancora disponibile. Shopify non blocca le scorte nel carrello: con 70 pezzi a lotto
     il pezzo c'è davvero per quei minuti. Ogni minuto le scorte si rileggono dal negozio (sezione sn-scorte). */
  var LOT = SY.lotto || {}, RES_MS = (LOT.min || 10) * 60000, resWas = 0, resEndUntil = 0;
  function resGet() { try { return JSON.parse(store('sy_res') || '{}') || {} } catch (e) { return {} } }
  function resPut(o) { store('sy_res', Object.keys(o).length ? JSON.stringify(o) : null) }
  function resClean() {
    var o = resGet(), now = Date.now(), ch = false;
    Object.keys(o).forEach(function (k) { if (!o[k] || !(o[k].until > now) || !(o[k].q > 0)) { delete o[k]; ch = true } });
    if (ch) resPut(o);
    return o;
  }
  function resQ(id) { var o = resClean(); return o[id] ? o[id].q : 0 }
  function resAdd(id, q) { var o = resClean(); o[id] = { q: (o[id] ? o[id].q : 0) + q, until: Date.now() + RES_MS }; resPut(o) }
  function resLeft() { var o = resClean(), m = 0; Object.keys(o).forEach(function (k) { m = Math.max(m, o[k].until - Date.now()) }); return m }
  /* il carrello vero comanda: se il pezzo non c'è più (tolto o comprato) la riserva sparisce */
  function resSync(cart) {
    if (!cart || !cart.items) return;
    var o = resClean(), inCart = {};
    cart.items.forEach(function (i) { inCart[i.variant_id || i.id] = (inCart[i.variant_id || i.id] || 0) + i.quantity });
    Object.keys(o).forEach(function (k) { var c = inCart[k] || 0; if (!c) delete o[k]; else if (o[k].q > c) o[k].q = c });
    resPut(o); render(); lotRender();
  }
  function mmss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2) }
  /* pezzi disponibili per chi guarda: scorte Shopify, meno quelli riservati nel suo carrello; la Coppia (SY.lotto.parti)
     prende un pezzo da ogni misura, quindi una Coppia riservata nel carrello si toglie da Baby e Classico e la Coppia
     non supera la misura più scarsa.
     13/10: le Coppie già VENDUTE non si sottraggono più: le scorte Shopify di Baby e Classico le contano già, e la scorta
     Shopify della Coppia è messa a mano (= paia possibili), non racconta quante Coppie sono uscite. Il 7/10 qualcuno l'ha
     portata da 63 a 29 e il sito ha letto "40 Coppie vendute": Classico a zero, "Esaurito", sei giorni senza ordini. */
  var PARTI = (SY.lotto || {}).parti || {};
  function byK(k) { for (var i = 0; i < P.length; i++) if (P[i].k === k) return P[i]; return null }
  function base(p) { return p.outShop ? 0 : p.left == null ? null : p.left }
  function usedBy(k) {
    var u = 0;
    Object.keys(PARTI).forEach(function (b) {
      var bp = byK(b); if (!bp || !bp.tot || PARTI[b].indexOf(k) < 0) return;
      u += resQ(bp.id);
    });
    return u;
  }
  function shown(p) {
    var b = base(p); if (b == null) return null;
    if (PARTI[p.k]) {
      var n = b - resQ(p.id);
      PARTI[p.k].forEach(function (k) { var c = byK(k), sc = c ? shown(c) : null; if (sc != null) n = Math.min(n, sc) });
      return Math.max(0, n);
    }
    return Math.max(0, b - resQ(p.id) - usedBy(p.k));
  }
  /* a zero nel lotto la misura si spegne anche se Shopify la venderebbe ancora */
  function poolOut() { P.forEach(function (p) { var n = p.tot ? shown(p) : null; p.out = p.outShop || n === 0 }) }
  function tween(el, from, to, ms) {
    cancelAnimationFrame(el._raf);
    if (reduce || from === to || !ms) { el.textContent = to; return }
    var t0 = 0;
    function step(ts) { if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / ms), e = 1 - Math.pow(1 - k, 3); el.textContent = Math.round(from + (to - from) * e); if (k < 1) el._raf = requestAnimationFrame(step) }
    el._raf = requestAnimationFrame(step);
  }
  var lotSeen = false;
  function lotRender(first) {
    $$('[data-lot-row]').forEach(function (row) {
      var p = null; for (var i = 0; i < P.length; i++) if (P[i].k === row.dataset.lotRow) p = P[i];
      if (!p || !p.tot) return;
      var n = shown(p), b = $('[data-lot-n]', row), bar = $('[data-lot-bar]', row);
      if (n == null) n = p.tot;
      var was = row._n == null ? p.tot : row._n;
      if (!lotSeen) { b.textContent = p.tot; bar.style.width = '100%'; return }  /* fermo al totale finché non si vede */
      if (row._n != null && n < row._n) {  /* un pezzo in meno mentre guardi: "−1" che vola via */
        var m = document.createElement('span'); m.className = 'lot-minus mono'; m.textContent = '−' + (row._n - n);
        $('.lot-top', row).appendChild(m); setTimeout(function () { m.remove() }, 1300);
      }
      row._n = n;
      tween(b, was, n, first ? 1600 : 700);
      bar.style.width = Math.max(0, Math.min(100, n / p.tot * 100)) + '%';
      row.classList.toggle('lot-row--out', n === 0);
      var low = $('[data-lot-low]', row); if (low) { low.hidden = !(n > 0 && n <= (LOT.low || 20)); row.classList.toggle('lot-row--low', !low.hidden) }  /* "Ultimi pezzi" vero, sotto la soglia */
    });
    var lot = $('[data-lot]');
    if (lot) {
      var tutti = P.filter(function (p) { return p.tot }), finito = tutti.length && tutti.every(function (p) { return shown(p) === 0 });
      var eb = $('[data-lot-eyebrow]', lot); if (eb) eb.textContent = finito ? T.lotOut : eb.dataset.base;
      shipText();
    }
    resPaint();
  }
  /* il tempo della riserva: nel blocco d'acquisto, nel riepilogo, nel carrello e nella barra in basso */
  function resPaint() {
    var left = resLeft(), on = left > 0, txt = on ? fmt(T.resFor, { t: mmss(left) }) : '';
    if (!on && resWas > 0) { resEndUntil = Date.now() + 8000; resWas = 0; render(); lotRender(); return }
    if (on) resWas = left;
    var ended = !on && Date.now() < resEndUntil;
    $$('[data-res]').forEach(function (e) {
      e.hidden = !on && !ended;
      e.classList.toggle('lot-res--end', ended);
      e.innerHTML = on ? '<b>' + escH(txt) + '</b><span>' + escH(T.resNote) + '</span>' : ended ? '<b>' + escH(T.resEnd) + '</b>' : '';
    });
    $$('[data-res-timer]').forEach(function (e) { e.textContent = txt; var l = e.closest('[data-res-line]') || e; l.hidden = !on });
    barName();
  }
  /* spedizioni: prima di SY.lotto.dal "Spedito da mercoledì 30 settembre", da quel giorno "Spedito in 48h" */
  function shipText() {
    var prima = LOT.dal && Date.now() < Date.parse(LOT.dal + 'T00:00:00+02:00');
    $$('[data-ship]').forEach(function (e) { e.textContent = prima ? (e.dataset.before || T.shipBefore) : T.lotShip });  /* data-before: frase propria del punto (27/09) */
  }
  shipText();
  function barName() {
    if (!P.length) return;
    var c = calc(), left = resLeft();
    $$('.bar .js-name').forEach(function (e) {
      var n = shown(c.p);
      e.textContent = left > 0 ? fmt(T.resFor, { t: mmss(left) })
        : c.p.out ? c.p.name + ' · ' + T.soldOut
        : c.p.pre ? T.preShip
        : c.p.tot && n != null && T.barLeft && !PARTI[c.p.k] ? fmt(T.barLeft, { name: c.p.name, n: n })
        : c.p.name + (c.q > 1 ? ' × ' + c.q : '') + ' · ' + c.p.g;
    });
  }
  setInterval(function () { if (resLeft() > 0 || resWas > 0 || resEndUntil) { resPaint(); if (resEndUntil && Date.now() > resEndUntil) { resEndUntil = 0; resPaint() } } }, 1000);
  (function () {
    var lot = $('[data-lot]'); if (!lot) return;
    function go() { if (lotSeen) return; lotSeen = true; lotRender(true) }
    if (!('IntersectionObserver' in window)) { go(); return }
    new IntersectionObserver(function (es, io) { es.forEach(function (x) { if (x.isIntersecting) { io.disconnect(); setTimeout(go, 250) } }) }, { threshold: .35 }).observe(lot);
  })();
  /* scorte dal vivo: ogni minuto si rileggono da Shopify (solo sul negozio, dove c'è window.SY_STOCK) */
  if (window.SY_STOCK && P.length) setInterval(function () {
    if (document.hidden) return;
    fetch(R + '?section_id=sn-scorte', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : '' }).then(function (tx) {
      var a = tx.indexOf('{'), b = tx.lastIndexOf('}'); if (a < 0 || b < a) return;
      var live = JSON.parse(tx.slice(a, b + 1));
      P.forEach(function (p) { var v = live[p.id]; if (v) { p.outShop = !v.ok; p.pre = !!v.pre; p.left = v.n != null && v.n > 0 ? v.n : null } });
      render(); lotRender();
    }).catch(function () {});
  }, 60000);
  function outK(k) { for (var i = 0; i < P.length; i++) if (P[i].k === k) return !!P[i].out; return false }
  function outPre(k) { for (var i = 0; i < P.length; i++) if (P[i].k === k) return !!P[i].pre; return false }
  var state = { k: SY.def || 'Classico', q: 1 };  /* se la taglia della pagina è esaurita resta scelta, ma non si può aggiungere */
  /* scheda prodotto: ?variant= sceglie la taglia (link da Google, Meta e catalogo) */
  var qv = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
  if (qv) P.forEach(function (p) { if (String(p.id) === qv) state.k = p.k });
  function prod() { for (var i = 0; i < P.length; i++) if (P[i].k === state.k) return P[i]; return P[0] }
  function pct(p, q) { if (!p.pack) return 0; for (var i = 0; i < PACKS.length; i++) if (q >= PACKS[i][0]) return PACKS[i][1]; return 0 }
  function calc() {
    var p = prod(), q = state.q;
    var sv = shown(p), mx = sv != null ? Math.max(1, sv) : 0;
    if (mx && q > mx) { q = state.q = mx }  /* non si può ordinare più di quello che c'è */
    var d = pct(p, q), full = p.p * q, tot = Math.round(full * (100 - d) / 100);
    return { p: p, q: q, d: d, full: full, tot: tot, each: Math.round(tot / q), save: full - tot };
  }
  /* spedizione: la tariffa che il checkout applicherà al paese del cliente.
     Sul negozio il paese lo passa il layout (localization di Shopify), in anteprima vale quello della lingua. */
  var CC = String(window.SY_COUNTRY || SY.country || '').toUpperCase();
  function shipFor() { var r = SY.shipRates || {}; return r[CC] != null ? r[CC] : null }
  function countryName() { try { return new Intl.DisplayNames([L], { type: 'region' }).of(CC) || '' } catch (e) { return '' } }
  function gallery(idx, now) {
    $$('.gal-track').forEach(function (t) {
      var f = t.children[idx]; if (!f) return;
      t.scrollTo({ left: f.offsetLeft, behavior: reduce || now ? 'auto' : 'smooth' });
    });
  }
  function render() {
    buyLabels();
    if (!P.length) return;
    poolOut();
    var c = calc();
    $$('.js-add').forEach(function (b) {
      if (b._html == null) b._html = b.innerHTML;
      b.disabled = !!c.p.out;
      b.classList.toggle('btn--off', !!c.p.out);
      if (c.p.out) { b.textContent = T.soldOut; b.setAttribute('aria-label', T.soldOutAria || T.soldOut); }
      else {
        if (!$('.js-total', b)) b.innerHTML = b._html;
        b.removeAttribute('aria-label');
        var lab = $('.js-cta', b);  /* "Aggiungi" diventa "Prenota" quando la taglia è su prenotazione */
        if (lab) lab.textContent = c.p.pre ? T.preCta : lab.dataset.base || lab.textContent;
      }
    });
    $$('[data-pre]').forEach(function (e) { e.hidden = !c.p.pre });
    $$('[data-size]').forEach(function (b) {
      var o = outK(b.dataset.size);
      b.setAttribute('aria-pressed', !o && b.dataset.size === state.k ? 'true' : 'false');
      b.classList.toggle('size--out', o);
      b.classList.toggle('size--pre', !o && outPre(b.dataset.size));
      if (o) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
    });
    P.forEach(function (p) {
      var n = shown(p);
      $$('.size-left[data-left="' + p.k + '"]').forEach(function (e) {
        e.textContent = PARTI[p.k] ? '' : p.tot && n != null && !p.out ? fmt(T.lotCard, { n: n }) : p.left && p.left <= 10 ? fmt(T.left, { n: p.left }) : '';
        e.hidden = !e.textContent;
      });
    });
    $$('[data-pack]').forEach(function (b) { b.setAttribute('aria-pressed', +b.dataset.pack === c.q ? 'true' : 'false') });
    $$('.packs').forEach(function (x) { x.classList.toggle('nodisc', !c.p.pack) });
    $$('.js-qty').forEach(function (i) { if (+i.value !== c.q) i.value = c.q });
    $$('.js-total').forEach(function (e) { e.textContent = money(c.tot) });
    var sc = shipFor();
    $$('.js-ship').forEach(function (e) {
      var fr = freeFor(sc, c.tot);  /* periodo gratis, soglia o codice: "Spedizione gratis · Totale" senza la tariffa */
      e.innerHTML = sc == null ? (T.vatShip || '&nbsp;') : (fr ? '<b class="ok">' + escH(T.shipFreeLine || T.freeShip) + '</b>' : fmt(T.shipPlus, { s: money(sc) })) + ' · <b>' + fmt(T.grand, { t: money(c.tot + (fr ? 0 : sc)) }) + '</b>';
    });
    $$('.js-old').forEach(function (e) { e.textContent = c.p.old ? money(c.p.old * c.q) : '' });
    $$('.js-unit').forEach(function (e) { e.textContent = money(c.p.p) });
    $$('.js-unit-old').forEach(function (e) { e.textContent = c.p.old ? money(c.p.old) : '' });
    /* nella barra, su prenotazione, conta la spedizione (il nome non ci sta a 390 px accanto al tasto) */
    $$('.js-name').forEach(function (e) { if (!e.closest('.bar')) e.textContent = c.p.name + (c.q > 1 ? ' × ' + c.q : '') + ' · ' + c.p.g });
    barName();
    /* stesso verbo dappertutto: "Prenota" se la misura scelta è su prenotazione, o se è esaurita e si può solo prenotare */
    var sp = soloPre();
    $$('.js-barcta').forEach(function (e) { e.textContent = c.p.pre || (c.p.out && sp) ? T.preCta : e.dataset.base });
    $$('.js-each').forEach(function (e) { e.textContent = c.q > 1 ? fmt(T.each, { p: money(c.each) }) : '' });
    $$('.js-save').forEach(function (e) {
      e.textContent = c.save ? fmt(T.save, { p: money(c.save), d: c.d }) : (c.p.pack ? T.packHint : T.noPack);
      e.classList.toggle('on', !!c.save);
    });
  }
  $$('[data-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (outK(b.dataset.size)) return;
      state.k = b.dataset.size; render();
      var p = prod(); if (p.img != null) gallery(p.img);
    });
  });
  $$('[data-pack]').forEach(function (b) { b.addEventListener('click', function () { state.q = +b.dataset.pack; render() }) });
  $$('[data-q]').forEach(function (b) { b.addEventListener('click', function () { state.q = Math.min(99, Math.max(1, state.q + +b.dataset.q)); render() }) });
  $$('.js-qty').forEach(function (i) {
    i.addEventListener('input', function () { var n = parseInt(i.value, 10); if (n >= 1) { state.q = Math.min(99, n); render() } });
    i.addEventListener('blur', function () { render() });
    i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); i.blur() } });
  });
  /* galleria: pallini e frecce */
  $$('.gal').forEach(function (g) {
    var t = $('.gal-track', g), dots = $$('.gal-dots button', g);
    function idx() { return Math.round(t.scrollLeft / Math.max(1, t.clientWidth)) }
    t.addEventListener('scroll', debounce(function () {
      var i = idx(); dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false') });
    }, 50), { passive: true });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { t.scrollTo({ left: k * t.clientWidth, behavior: 'smooth' }) }) });
    $$('[data-gal]', g).forEach(function (b) {
      b.addEventListener('click', function () { var n = t.children.length; t.scrollTo({ left: ((idx() + +b.dataset.gal + n) % n) * t.clientWidth, behavior: 'smooth' }) });
    });
  });

  /* ---------- carrello ---------- */
  var busy = false, tagged = false, sheetOpen = false, popOpen = false;
  var codeOn = function () { return !!store('sy_code') };
  /* spedizione gratis (27/09): il codice della finestra azzera le tariffe fino a SY.freeShip.max (Italia e UE) */
  var FREE = SY.freeShip || null;
  function codeFree() { var c = store('sy_code'); return !!(FREE && c && String(c).toUpperCase() === FREE.code) }
  function todayISO() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) }
  /* 01/10 (Danilo): spedizione gratis in tutta Europa fino al 31 ottobre, senza codice: Italia e UE (SY.freeShip.zones), fino a SY.freeShip.until compreso,
     come lo sconto automatico in Shopify. Il codice vecchio resta valido per chi lo ha già. */
  function periodFree() { return !!(FREE && FREE.until && todayISO() <= FREE.until && (!CC || !FREE.zones || FREE.zones.indexOf(CC) > -1)) }
  /* 15/10 (Danilo): spedizione gratis da SY.freeShip.min di prodotti (150 €) in Italia e UE, come lo sconto automatico in Shopify */
  function inZone() { return !!(FREE && (!CC || !FREE.zones || FREE.zones.indexOf(CC) > -1)) }
  function minFree(sub) { return !!(FREE && FREE.min && sub != null && sub >= FREE.min && inZone()) }
  function freeOn(sub) { return periodFree() || codeFree() || minFree(sub) }
  function freeFor(sc, sub) { return freeOn(sub) && sc != null && sc <= FREE.max }
  /* pagina carrello (Liquid): se il codice c'è, la riga spedizione dice "Gratis" e il totale la toglie */
  (function () {
    var row = $('[data-ship-row]'), gr = $('[data-grand]'); if (!row || !gr) return;
    var sc = row.dataset.c === '' ? null : +row.dataset.c;
    if (!freeFor(sc, sc == null ? null : +gr.dataset.c - sc)) return;
    $('b', row).innerHTML = '<s class="was">' + money(sc) + '</s> ' + escH(T.freeShip);
    row.classList.add('line--ok');
    $('b', gr).textContent = money(+gr.dataset.c - sc);
  })();
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function count() {
    return fetch(R + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null })
      .then(function (c) {
        if (c) { $$('.js-count').forEach(function (e) { e.textContent = c.item_count; e.classList.toggle('zero', !c.item_count) }); resSync(c) }
        return c;
      }).catch(function () { return null });
  }
  function nameOf(item) {
    var id = String(item.variant_id || item.id);
    for (var i = 0; i < P.length; i++) if (String(P[i].id) === id) return 'Stampify ' + P[i].name;
    return item.product_title;
  }
  function checkoutUrl(to) {
    var code = store('sy_code');
    return code ? R + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(to) : to;
  }
  function openSheet(cart, c) {
    var sh = $('#sheet'); if (!sh) return;
    var lines = '', sub, codeApplied = [];
    if (cart && cart.items && cart.items.length) {
      cart.items.forEach(function (i) {
        lines += '<div class="line"><span>' + i.quantity + ' × ' + nameOf(i) + '</span><b>' + money(i.original_line_price || i.line_price) + '</b></div>';
        var pr = i.properties || {};
        Object.keys(pr).forEach(function (k) { if (k.charAt(0) !== '_' && pr[k]) lines += '<div class="line line--pre"><span>' + escH(k) + ' · ' + escH(pr[k]) + '</span></div>' });
      });
      /* final_line_price ha lo sconto quantità ma non il codice: il codice va su una riga sua */
      var disc = 0; cart.items.forEach(function (i) { disc += (i.original_line_price || i.line_price) - (i.final_line_price != null ? i.final_line_price : i.line_price) });
      if (disc > 0) lines += '<div class="line line--ok"><span>' + T.packLine + '</span><b>−' + money(disc) + '</b></div>';
      codeApplied = (cart.cart_level_discount_applications || []).filter(function (d) { return d.total_allocated_amount > 0 });
      codeApplied.forEach(function (d) { lines += '<div class="line line--ok"><span>' + fmt(T.codeIn, { c: d.title }) + '</span><b>−' + money(d.total_allocated_amount) + '</b></div>' });
      sub = cart.total_price;
    } else {
      lines = '<div class="line"><span>' + c.q + ' × Stampify ' + c.p.name + '</span><b>' + money(c.full) + '</b></div>';
      if (c.p.pre) lines += '<div class="line line--pre"><span>' + T.preOrder + ' · ' + T.preShip + '</span></div>';
      if (c.save) lines += '<div class="line line--ok"><span>' + T.packLine + '</span><b>−' + money(c.save) + '</b></div>';
      sub = c.tot;
    }
    var extra = '';
    var sc = shipFor(), cn = countryName(), free = freeFor(sc, sub);
    /* vecchio codice 10% (chi l'ha preso prima del 27/09): resta la sua riga */
    if (codeOn() && !freeOn(sub) && !codeApplied.length) extra += '<div class="line line--ok"><span>' + fmt(T.codeLine, { c: store('sy_code') }) + '</span><b>' + T.ten + '</b></div>';
    extra += '<div class="line' + (free ? ' line--ok' : '') + '"><span>' + (cn ? fmt(T.shipTo, { p: cn }) : T.shipRow) + '</span><b>' +
      (sc == null ? T.shipLater : free ? '<s class="was">' + money(sc) + '</s> ' + escH(T.freeShip) : money(sc)) + '</b></div>';
    if (free) sc = 0;
    /* totale finale: prodotti, meno il 10% se c'è il vecchio codice, più la spedizione (zero col codice della spedizione gratis) */
    var pending = codeOn() && !freeOn(sub) && !codeApplied.length ? Math.round(sub / 10) : 0;
    lines += '<div class="line line--res" data-res-line hidden><span data-res-timer></span></div>';
    $('#shLines').innerHTML = lines; resPaint();
    $('#shTot').textContent = money(sub);
    var gr = $('#shGrand'); if (gr) gr.textContent = money(sub - pending + (sc || 0));
    var ex = $('#shExtra'); if (ex) ex.innerHTML = extra;
    $('#shPay').setAttribute('href', checkoutUrl(R + 'checkout'));
    /* dati per la fattura già dati in questo carrello */
    var inv = $('#shInv');
    if (inv) {
      var at = (cart && cart.attributes) || {};
      inv.checked = at.Fattura === 'Sì';
      sh.classList.toggle('inv-on', inv.checked);
      $('#shInvF').hidden = !inv.checked;
      $$('#shInvF [data-attr]').forEach(function (i) { i.value = at[i.dataset.attr] || ''; i.closest('.fld').classList.remove('bad') });
    }
    var sc = $('#shCart'); if (sc) sc.setAttribute('href', checkoutUrl(R + 'cart'));
    sheetOpen = true; sh.classList.add('open'); sh.setAttribute('aria-hidden', 'false'); barState();
    express();
    setTimeout(function () { var b = $('#shPay'); b && b.focus({ preventScroll: true }) }, 60);
  }
  /* 03/10 (punto 2): tasti di pagamento veloce (PayPal, Apple Pay, Google Pay, Shop Pay) nel riepilogo. Shopify li disegna per il carrello di
     questo momento (sezione sn-express, Section Rendering API); se non arrivano il riquadro resta nascosto e resta "Vai al pagamento". */
  function express() {
    var box = $('#shExpress'), slot = box && $('.sh-express-b', box); if (!slot) return;
    /* niente intestazione Accept: JSON, con quella Shopify restituisce la sezione senza i tasti (provato il 03/10) */
    fetch(R + '?sections=sn-express', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null })
      .then(function (j) {
        var h = j && j['sn-express'];
        if (!h || !/accelerated-checkout|data-express-anteprima/.test(h)) { box.hidden = true; return }
        slot.innerHTML = h; box.hidden = false;
      })
      .catch(function () { box.hidden = true });
  }
  function closeSheet() { var sh = $('#sheet'); if (!sh) return; sh.classList.remove('open'); sh.setAttribute('aria-hidden', 'true'); sheetOpen = false; barState() }
  function add() {
    if (busy || !P.length) return; busy = true;
    var c = calc(), btns = $$('.js-add');
    btns.forEach(function (b) { b.classList.add('busy') });
    var it = { id: c.p.id, quantity: c.q };
    /* su prenotazione: la nota va sulla riga, così Shopify la mostra in checkout, nell'ordine e nell'email di conferma */
    if (c.p.pre) { it.properties = {}; it.properties[T.preOrder] = T.preShip.replace(/\u2060/g, '') }
    post(R + 'cart/add.js', { items: [it] })
      .then(function (r) {
        if (!r.ok) throw new Error('add ' + r.status);
        if (tagged || !SY.variant) return null;
        return post(R + 'cart/update.js', { attributes: { landing: SY.variant + '-' + L } }).catch(function () {});
      })
      .then(function () { tagged = true; return count() })
      .then(function (cart) {
        /* la riserva si promette solo con scorte larghe (almeno 10 pezzi): Shopify non tiene il pezzo nel carrello */
        var lib = shown(c.p); if (lib != null && lib >= 10) resAdd(c.p.id, c.q);
        lotSeen = true; render(); lotRender();
        if (window.fbq) try { fbq('track', 'AddToCart', { value: c.tot / 100, currency: 'EUR', content_ids: [String(c.p.id)], content_type: 'product' }) } catch (e) {}
        /* dal carrello vuoto: si ricarica la pagina, che mostra subito le righe vere */
        if (SY.variant === 'carrello') { location.reload(); return }
        openSheet(cart, c);
      })
      .catch(function () {
        /* se la chiamata veloce non va, si usa il modulo classico: l'ordine non si perde */
        var f = $('#addform');
        if (f) {
          f.elements.id.value = c.p.id; f.elements.quantity.value = c.q;
          var pi = f.querySelector('[data-pre-prop]');
          if (c.p.pre) {
            if (!pi) { pi = document.createElement('input'); pi.type = 'hidden'; pi.setAttribute('data-pre-prop', ''); f.appendChild(pi) }
            pi.name = 'properties[' + T.preOrder + ']'; pi.value = T.preShip.replace(/\u2060/g, '');
          } else if (pi) pi.parentNode.removeChild(pi);
          f.submit();
        }
      })
      .then(function () { busy = false; btns.forEach(function (b) { b.classList.remove('busy') }) });
  }
  $$('.js-add').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); if (prod().out) return; add() }) });
  $$('[data-close-sheet]').forEach(function (b) { b.addEventListener('click', closeSheet) });
  /* riepilogo: "Mi serve la fattura". Ragione sociale e codice fiscale/P.IVA diventano obbligatori e finiscono
     negli attributi del carrello (nell'ordine: Dettagli aggiuntivi) prima di andare al pagamento */
  var shInv = $('#shInv');
  if (shInv) {
    shInv.addEventListener('change', function () {
      $('#shInvF').hidden = !shInv.checked;
      $('#sheet').classList.toggle('inv-on', shInv.checked);
      if (shInv.checked) { var f1 = $('#shInvF [data-attr]'); if (f1) f1.focus({ preventScroll: false }) }
    });
    $$('#shInvF [data-attr]').forEach(function (i) { i.addEventListener('input', function () { i.closest('.fld').classList.remove('bad') }) });
    $('#shPay').addEventListener('click', function (e) {
      e.preventDefault();
      var btn = this, href = btn.getAttribute('href'), a = { Fattura: shInv.checked ? 'Sì' : '' }, first = null;
      $$('#shInvF [data-attr]').forEach(function (i) {
        var v = i.value.trim(), bad = shInv.checked && i.required && !v;
        i.closest('.fld').classList.toggle('bad', bad);
        if (bad && !first) first = i;
        a[i.dataset.attr] = shInv.checked ? v : '';
      });
      if (first) { first.focus(); return }
      btn.classList.add('busy');
      post(R + 'cart/update.js', { attributes: a }).catch(function () {}).then(function () { location.href = href });
    });
  }
  var sh = $('#sheet');
  if (sh) sh.addEventListener('click', function (e) { if (e.target === sh) closeSheet() });

  /* ---------- pagina carrello (tema Shopify, sections/sn-carrello.liquid) ----------
     quantità e "rimuovi" passano da /cart/change.js, poi la sezione si ridisegna da Shopify (prezzi e sconti veri);
     telefono, fattura e note si salvano mentre si scrive, così non si perdono ridisegnando o pagando con PayPal/Google Pay */
  function cartForm() { return $('#snCartForm') }
  function cartAttrs() {
    var f = cartForm(); if (!f) return null;
    var a = {};
    $$('[name^="attributes["]', f).forEach(function (i) {
      if (i.type === 'hidden') return;
      a[i.name.slice(11, -1)] = i.type === 'checkbox' ? (i.checked ? i.value : '') : i.value;
    });
    return { attributes: a, note: f.elements.note ? f.elements.note.value : '' };
  }
  function saveCart() { var d = cartAttrs(); return d ? post(R + 'cart/update.js', d).catch(function () {}) : Promise.resolve() }
  var saveCartLater = debounce(saveCart, 600);
  function cartChange(line, q) {
    var box = $('[data-sn-cart]'); if (!box || box.classList.contains('busy')) return;
    box.classList.add('busy');
    /* dopo il ridisegno il fuoco della tastiera torna sullo stesso comando della stessa riga */
    var ae = document.activeElement, fr = ae && ae.closest ? ae.closest('[data-line]') : null;
    var fKey = !fr ? null : ae.hasAttribute('data-line-step') ? '[data-line-step="' + ae.dataset.lineStep + '"]' : ae.hasAttribute('data-line-qty') ? '[data-line-qty]' : null;
    var url = location.pathname + (location.search ? location.search + '&' : '?') + 'section_id=' + encodeURIComponent(box.dataset.sectionId);
    saveCart()
      .then(function () { return post(R + 'cart/change.js', { line: line, quantity: q }) })
      .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return fetch(url, { credentials: 'same-origin' }) })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text() })
      .then(function (h) {
        var d = document.createElement('div'); d.innerHTML = h;
        var nb = d.querySelector('[data-sn-cart]'); if (!nb) throw new Error('markup');
        /* carrello rimasto vuoto: si ricarica la pagina, così il blocco di scelta ha i suoi comandi */
        if (!nb.querySelector('.cl')) { location.reload(); return }
        box.replaceWith(nb); count();
        var tg = fKey && nb.querySelector('[data-line="' + fr.dataset.line + '"] ' + fKey); if (tg) tg.focus({ preventScroll: true });
      })
      .catch(function () { location.reload() });
  }
  if ($('[data-sn-cart]')) {
    document.addEventListener('click', function (e) {
      var st = e.target.closest('[data-sn-cart] [data-line-step]');
      if (st) {
        var row = st.closest('[data-line]'), inp = $('[data-line-qty]', row);
        cartChange(+row.dataset.line, Math.max(0, Math.min(99, (parseInt(inp.value, 10) || 0) + +st.dataset.lineStep)));
        return;
      }
      var rm = e.target.closest('[data-sn-cart] [data-line-rm]');
      if (rm) { e.preventDefault(); cartChange(+rm.closest('[data-line]').dataset.line, 0) }
    });
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t.closest('[data-sn-cart]')) return;
      if (t.matches('[data-line-qty]')) {
        var n = parseInt(t.value, 10);
        cartChange(+t.closest('[data-line]').dataset.line, n >= 0 ? Math.min(99, n) : 1);
        return;
      }
      if (t.matches('[data-invoice-toggle]')) {
        var fs = $('[data-invoice-fields]');
        if (fs) { fs.hidden = !t.checked; if (!t.checked) $$('input', fs).forEach(function (i) { i.value = '' }) }
      }
      saveCartLater();
    });
    document.addEventListener('input', function (e) {
      var t = e.target; if (t.closest('[data-sn-cart]') && !t.matches('[data-line-qty]')) saveCartLater();
    });
    /* fattura chiesta: ragione sociale e codice fiscale/P.IVA obbligatori prima del pagamento */
    document.addEventListener('submit', function (e) {
      var f = e.target; if (f.id !== 'snCartForm') return;
      var tg = $('[data-invoice-toggle]', f); if (!tg || !tg.checked) return;
      var first = null;
      $$('[data-inv-req]', f).forEach(function (i) { var bad = !i.value.trim(); i.closest('.fld').classList.toggle('bad', bad); if (bad && !first) first = i });
      if (first) {
        e.preventDefault();
        first.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () { first.focus({ preventScroll: true }) }, 300);
      }
    }, true);
    document.addEventListener('input', function (e) { var t = e.target; if (t.matches && t.matches('[data-inv-req]') && t.value.trim()) t.closest('.fld').classList.remove('bad') });
    /* Invio nel campo quantità non deve mandare al pagamento */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-sn-cart] [data-line-qty]')) { e.preventDefault(); e.target.blur() }
    });
  }

  /* ---------- barra fissa in basso ---------- */
  /* sul telefono la barra c'è da subito (il tasto per comprare si vede nel primo schermo) e sparisce
     quando un blocco d'acquisto è a schermo, sul piede e con riepilogo o finestra aperti */
  var bar = $('#bar'), buySeen = {}, footSeen = false;
  /* la barra resta SEMPRE ferma in basso: niente comparse e sparizioni mentre si scorre (bug segnalato il 24/09).
     Si alza solo il contenuto della pagina, con --barh, così non finisce mai sotto la barra. */
  function barState() {
    if (!bar) return;
    bar.classList.add('up');
    doc.classList.add('bar-up');
    var h = Math.round(bar.getBoundingClientRect().height);
    if (h && h !== barH) { barH = h; doc.style.setProperty('--barh', h + 'px') }
  }
  var barH = 0;
  if (bar) {
    barState();
    addEventListener('resize', barState);
    addEventListener('orientationchange', barState);
    if (window.ResizeObserver) new ResizeObserver(barState).observe(bar);
  }

  /* "Acquista" della barra in basso e "Compra" in alto: riportano al blocco di scelta, centrato e evidenziato,
     invece di aggiungere subito il Classico (chi scorre non deve comprare per sbaglio la misura sbagliata) */
  $$('a[href="#acquista"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var box = $('#acquista'); if (!box) return;
      e.preventDefault(); menu(false);
      /* se il blocco sta nello schermo (tra testata e barra) lo centra; se è più alto, porta in vista le misure e "Aggiungi" */
      var r = box.getBoundingClientRect(), nav = $('.nav'), top = nav ? nav.getBoundingClientRect().bottom : 0;
      var low = innerHeight - (bar ? bar.getBoundingClientRect().height : 0), q = $('.qrow', box), y;
      if (r.height <= low - top - 16) y = sY() + r.top - top - (low - top - r.height) / 2;
      else y = sY() + (q ? q.getBoundingClientRect().bottom : r.bottom) - low + 14;
      sTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      box.classList.remove('pulse'); void box.offsetWidth; box.classList.add('pulse');
    });
  });

  /* scelta manuale della lingua: vince sul rimando automatico alla lingua del browser (layout, REDIRECT_LINGUA) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[hreflang]');
    if (a) try { document.cookie = 'sy_lang=' + a.getAttribute('hreflang').slice(0, 2) + '; path=/; max-age=31536000; SameSite=Lax' } catch (e2) {}
  }, true);

  /* ---------- coupon 10% fluttuante ----------
     linguetta in basso a sinistra: la scheda si apre da sola una volta (dopo SY.popup.delay secondi, non se
     il codice c'è già o se è stata chiusa da poco) e poi si apre e chiude con la linguetta */
  var pop = $('#pop');
  function markCode() {
    var on = freeOn(null);  /* qui conta solo periodo o codice: la soglia dipende dal carrello */
    doc.classList.toggle('has-code', codeFree());  /* la nota del codice solo a chi ha davvero il codice */
    doc.classList.toggle('free-ship', on);
    $$('[data-free]').forEach(function (e) { e.hidden = !(periodFree() || (FREE && FREE.min && inZone())) });
    if (pop) pop.classList.toggle('done', on);
  }
  markCode();
  if (pop && SY.popup && SY.popup.code) {
    var CODE = SY.popup.code, autoDone = false, popTab = $('.pop-tab', pop), popBox = $('.pop-box', pop);
    var last = +store('sy_pop_closed') || 0;
    var blocked = store('sy_code') === CODE || (Date.now() - last < (SY.popup.pauseDays || 3) * 864e5) || /[?&]nopopup/.test(location.search);
    function setPop(open, focus) {
      popOpen = open; barState();
      pop.classList.toggle('open', open);
      popBox.setAttribute('aria-hidden', open ? 'false' : 'true');
      popTab.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focus) setTimeout(function () {
        var i = pop.classList.contains('done') ? $('.pop-2 .btn', pop) : $('input[type=email]', pop);
        if (i && (wide() || focus === 'kb')) i.focus({ preventScroll: true });
      }, 420);
    }
    /* sul negozio vero (UE) Shopify mostra il banner dei cookie in basso: linguetta e scheda aspettano che venga chiuso */
    function cookieOn() {
      if (document.documentElement.classList.contains('ck-on')) return true;  /* banner nostro (27/09) */
      var cb = document.getElementById('shopify-pc__banner'), cs = cb && getComputedStyle(cb);
      return !!(cb && cb.getClientRects().length && cs.display !== 'none' && cs.visibility !== 'hidden');
    }
    function onScreen(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight }
    /* la linguetta non copre mai il blocco d'acquisto (prezzo, spedizione, totale) né il film dello stampo (audit 25/09) */
    var buyBox = $('#acquista'), filmBox = $('.sy2-film'), passed = false, t0 = Date.now(), autoY = null;
    function popState() {
      var s = { buy: onScreen(buyBox), film: onScreen(filmBox), cb: cookieOn() };
      if (buyBox ? !s.buy && buyBox.getBoundingClientRect().bottom < 0 : sY() > innerHeight) passed = true;
      pop.classList.toggle('hide-tab', s.buy || s.film || s.cb);
      return s;
    }
    function openPop() {
      if (autoDone || blocked || popOpen || sheetOpen || tagged || document.hidden) return;
      var a = document.activeElement;
      if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return;
      if (drawer && drawer.classList.contains('open')) return;
      var st = popState();
      if (st.buy || st.film || st.cb) return;
      autoDone = true; autoY = sY(); setPop(true, false);  /* il fuoco solo se la apre il visitatore */
    }
    /* apertura da sola: mai sul primo schermo né sopra il tasto d'acquisto; dopo che si è passato il blocco d'acquisto
       (o dopo 40 s), e mai prima di SY.popup.delay secondi */
    var lastScroll = 0, popIdle = null;
    function autoPop() {
      popState();
      if (autoDone || blocked) return;
      if (Date.now() - lastScroll < 600) return;  /* mai a metà di uno scorrimento: si aspetta che la pagina sia ferma */
      var dt = Date.now() - t0;
      if (dt < (SY.popup.delay || 8) * 1000) return;
      if (!passed && dt < 40000) return;
      openPop();
    }
    function closePop() {
      var inside = pop.contains(document.activeElement);
      setPop(false); autoY = null;
      if (!codeOn()) store('sy_pop_closed', Date.now());
      if (inside) popTab.focus({ preventScroll: true });
    }
    var popTick = false;
    SC.addEventListener('scroll', function () {
      lastScroll = Date.now();
      clearTimeout(popIdle); popIdle = setTimeout(autoPop, 700);
      if (popTick) return; popTick = true;
      requestAnimationFrame(function () {
        popTick = false; popState();
        /* aperta da sola e il visitatore continua a scorrere: torna linguetta (se non sta scrivendo l'email) */
        var a = document.activeElement;
        if (popOpen && autoY != null && Math.abs(sY() - autoY) > 280 && !(a && pop.contains(a) && a.tagName === 'INPUT')) closePop();
      });
    }, { passive: true });
    setInterval(autoPop, 1500);
    popState();
    if (!blocked) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 6 && wide()) openPop() });
    popTab.addEventListener('click', function (e) { autoDone = true; autoY = null; setPop(!popOpen, e.detail === 0 ? 'kb' : true) });
    /* striscia della spedizione gratis nella barra in basso (27/09): apre la finestra (con il codice, se c'è già) */
    $$('[data-open-pop]').forEach(function (b) { b.addEventListener('click', function (e) { autoDone = true; autoY = null; setPop(true, e.detail === 0 ? 'kb' : true) }) });
    $$('[data-close-pop]', pop).forEach(function (b) { b.addEventListener('click', closePop) });
    /* spedizione gratis: sulla foto la tariffa del paese barrata, sotto il testo quanto si risparmia */
    (function () {
      var sc = shipFor(), ok = FREE && sc != null && sc > 0 && sc <= FREE.max, o = $('[data-pop-old]', pop), sv = $('[data-pop-save]', pop);
      if (o) o.textContent = ok ? money(sc) : '';
      if (sv && ok) { sv.textContent = sv.dataset.tpl.replace('{s}', money(sc)); sv.hidden = false }
    })();
    var pf = $('form', pop);
    pf.addEventListener('submit', function (e) {
      e.preventDefault();
      var em = pf.elements['contact[email]'], fld = em.closest('.fld');
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em.value.trim());
      fld.classList.toggle('bad', !ok);
      if (!ok) { em.focus(); return }
      var btn = $('button[type=submit]', pf); btn.classList.add('busy');
      var fd = new FormData(pf);
      /* iscrizione come cliente Shopify (newsletter); il codice si mostra comunque, anche se la chiamata non va */
      fetch(R + 'contact', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .catch(function () {})
        .then(function () {
          store('sy_code', CODE); markCode();
          btn.classList.remove('busy');
          fetch(R + 'discount/' + encodeURIComponent(CODE), { credentials: 'same-origin', redirect: 'follow' }).catch(function () {});
          if (window.fbq) try { fbq('track', 'Lead') } catch (e2) {}
        });
    });
    $$('[data-copy]', pop).forEach(function (b) {
      b.addEventListener('click', function () {
        function done() { b.textContent = T.copied; setTimeout(function () { b.textContent = T.copy }, 1800) }
        if (navigator.clipboard) navigator.clipboard.writeText(CODE).then(done, done); else done();
      });
    });
  }
  addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (pop && pop.classList.contains('open')) $('[data-close-pop]', pop).click();
    else if (sheetOpen) closeSheet();
    else if (drawer && drawer.classList.contains('open')) menu(false);
  });

  /* ---------- quale misura: "Scegli Baby/Classico" sceglie la taglia nel blocco d'acquisto e ci riporta ---------- */
  $$('[data-pick]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var b = $('.size[data-size="' + a.dataset.pick + '"]');
      if (!b) return;
      e.preventDefault();
      b.click();
      var box = $('#acquista');
      if (box) box.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      var add = $('.js-add');
      if (add) setTimeout(function () { add.focus({ preventScroll: true }) }, reduce ? 0 : 500);
    });
  });

  /* ---------- produzione: rullino di foto vere e foto a schermo pieno ----------
     Le foto stanno in una striscia che scorre di lato; un clic la apre grande con frecce, Esc e scorrimento col dito. */
  (function () {
    var sec = $('[data-fab]');
    if (!sec) return;
    var track = $('[data-fab-track]', sec), bar = $('[data-fab-bar]', sec);
    var btns = $$('[data-fab-open]', sec);
    if (!track || !btns.length) return;
    function esc(x) { return String(x || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') }
    var foto = btns.map(function (b) {
      var im = $('img', b), cap = $('.fab-cap', b);
      return { src: im.getAttribute('src'), set: im.getAttribute('srcset'), alt: im.getAttribute('alt') || '', cap: cap ? cap.textContent : '' };
    });

    /* barra di avanzamento sotto il rullino */
    function prog() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      var vis = Math.min(1, track.clientWidth / track.scrollWidth);
      bar.style.width = (vis * 100).toFixed(2) + '%';
      var q = max > 0 ? track.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (q * (1 / vis - 1) * 100).toFixed(2) + '%)';
    }
    track.addEventListener('scroll', function () { requestAnimationFrame(prog) }, { passive: true });
    addEventListener('resize', debounce(prog, 120));
    prog();

    /* foto a schermo pieno */
    var view = null, vImg, vCap, vN, idx = -1, prevFocus = null;
    function build() {
      view = document.createElement('div');
      view.className = 'fab-view';
      view.setAttribute('role', 'dialog');
      view.setAttribute('aria-modal', 'true');
      view.tabIndex = -1;
      view.innerHTML = '<div class="fab-view-top"><span class="fab-view-n mono"></span>' +
        '<button type="button" class="fab-x" data-fab-x aria-label="' + esc(sec.dataset.close) + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<div class="fab-view-stage" data-fab-stage><img alt="">' +
        '<button type="button" class="fab-nav fab-nav--l" data-fab-go="-1" aria-label="' + esc(sec.dataset.prev) + '">‹</button>' +
        '<button type="button" class="fab-nav fab-nav--r" data-fab-go="1" aria-label="' + esc(sec.dataset.next) + '">›</button></div>' +
        '<p class="fab-view-cap"></p>';
      document.body.appendChild(view);
      vImg = $('img', view); vCap = $('.fab-view-cap', view); vN = $('.fab-view-n', view);
      view.addEventListener('click', function (e) {
        if (e.target.closest('[data-fab-x]')) return close();
        var go = e.target.closest('[data-fab-go]');
        if (go) return show(idx + (+go.dataset.fabGo));
        if (e.target === view || e.target.closest('[data-fab-stage]') === e.target) close();
      });
      var x0 = null;
      view.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX }, { passive: true });
      view.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
      });
    }
    function show(i) {
      i = (i + foto.length) % foto.length;
      idx = i;
      var f = foto[i];
      vImg.setAttribute('src', f.src);
      if (f.set) vImg.setAttribute('srcset', f.set);
      vImg.setAttribute('sizes', '96vw');
      vImg.setAttribute('alt', f.alt);
      vCap.textContent = f.cap;
      vN.textContent = (i + 1) + ' / ' + foto.length;
      var b = btns[i];
      if (b && b.parentNode.scrollIntoView) b.parentNode.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
    function open(i) {
      if (!view) build();
      prevFocus = document.activeElement;
      show(i);
      doc.classList.add('lock');
      void view.offsetWidth;  /* niente requestAnimationFrame: in una scheda non attiva non scatterebbe e la foto resterebbe invisibile */
      view.classList.add('on');
      view.focus({ preventScroll: true });
    }
    function close() {
      if (!view) return;
      view.classList.remove('on');
      doc.classList.remove('lock');
      if (prevFocus && prevFocus.focus) prevFocus.focus();
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { open(i) }) });
    addEventListener('keydown', function (e) {
      if (!view || !view.classList.contains('on')) return;
      if (e.key === 'Escape') { e.stopPropagation(); close() }
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    }, true);
  })();

  /* ---------- moduli (contatti e rivenditori) ---------- */
  function valid(f) {
    var bad = null;
    $$('[required]', f).forEach(function (i) {
      var box = i.closest('.fld') || i.closest('.chk'), ok;
      if (i.type === 'checkbox') ok = i.checked;
      else if (i.type === 'radio') ok = !!f.querySelector('input[name="' + i.name + '"]:checked');
      else if (i.type === 'email') ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim());
      else ok = i.value.trim() !== '';
      if (box) box.classList.toggle('bad', !ok);
      if (!ok && !bad) bad = i;
    });
    return bad;
  }
  $$('form.f').forEach(function (f) {
    f.setAttribute('novalidate', '');
    f.addEventListener('submit', function (e) {
      var bad = valid(f);
      if (bad) {
        e.preventDefault();
        (bad.closest('.fld') || bad.closest('.chk') || bad).scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () { try { bad.focus({ preventScroll: true }) } catch (x) {} }, 350);
        return;
      }
      /* il testo del messaggio riassume anche le scelte, così nella mail di Shopify si legge tutto in ordine */
      var sum = f.querySelector('[data-summary]');
      if (sum) sum.value = summary(f);
      var btn = $('button[type=submit]', f); if (btn) btn.classList.add('busy');
      if (window.fbq) try { fbq('track', f.dataset.lead === 'dealer' ? 'SubmitApplication' : 'Contact') } catch (x) {}
    });
    $$('input,select,textarea', f).forEach(function (i) {
      i.addEventListener(i.type === 'radio' || i.type === 'checkbox' || i.tagName === 'SELECT' ? 'change' : 'input', function () {
        var box = i.closest('.fld') || i.closest('.chk'); if (box && box.classList.contains('bad')) valid(f);
      });
    });
  });
  function summary(f) {
    var out = [];
    $$('[data-label]', f).forEach(function (i) {
      if ((i.type === 'radio' || i.type === 'checkbox') && !i.checked) return;
      var v = (i.value || '').trim(); if (!v) return;
      out.push(i.dataset.label + ': ' + v);
    });
    return out.join('\n');
  }
  $$('[data-wa-form]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.getElementById(b.dataset.waForm);
      var txt = (b.dataset.intro || '') + '\n' + (f ? summary(f) : '');
      window.open('https://wa.me/' + WA + '?text=' + encodeURIComponent(txt.trim()), '_blank', 'noopener');
    });
  });
  if (/[?&]contact_posted=true/.test(location.search)) {
    $$('.form-box').forEach(function (b) { b.classList.add('posted') });
    var ok = $('.f-ok'); if (ok) setTimeout(function () { ok.scrollIntoView({ block: 'center' }) }, 200);
  }
  /* argomento preselezionato dal link (es. contatti?argomento=postazioni) */
  var arg = (location.search.match(/[?&]argomento=([\w-]+)/) || [])[1];
  if (arg) { var ra = $('input[name="contact[argomento]"][data-key="' + arg + '"]'); if (ra) ra.checked = true }

  /* ---------- film del prodotto: lo scroll guida la camera ----------
     Invariato dalla bozza approvata: fotogrammi scaricati come file e decodificati in anticipo (ImageBitmap);
     la tela si ridisegna solo quando il fotogramma giusto e' pronto, cosi' su iPhone non lampeggia. */
  (function () {
    var sec = document.getElementById('giro'); if (!sec) return;
    var cv = sec.querySelector('canvas'), ctx = cv.getContext('2d');
    var N = +sec.dataset.frames, base = sec.dataset.path, ext = sec.dataset.ext;
    var CH = (sec.dataset.chapters || '0').split(',').map(Number);
    var KEYS = (sec.dataset.keys || ('0:0,1:' + (N - 1))).split(',').map(function (x) { var a = x.split(':'); return [+a[0], +a[1]] });
    function frameAt(p) {
      for (var k = 1; k < KEYS.length; k++) { if (p <= KEYS[k][0]) { var a = KEYS[k - 1], b = KEYS[k], t = (p - a[0]) / Math.max(1e-6, b[0] - a[0]); return a[1] + (b[1] - a[1]) * t } }
      return KEYS[KEYS.length - 1][1];
    }
    var titles = [].slice.call(sec.querySelectorAll('.sy2-film-titles h3'));
    var descs = [].slice.call(sec.querySelectorAll('.sy2-film-descs p'));
    var rail = sec.querySelector('.sy2-film-rail i'), cnt = sec.querySelector('.sy2-film-count b');
    var blobs = new Array(N), bmps = new Array(N), decoding = {}, nDecoding = 0;
    var target = 0, shown = 0, running = false, visible = false, chap = -1, lastF = -1, drawn = 0, fallbacks = 0;
    var RADIUS = 10, KEEP = 20, active = 0;
    function url(i) { return base + ('00' + i).slice(-3) + ext }
    /* il CDN di Shopify, senza "image/webp" in Accept, manda i fotogrammi in PNG (427 KB invece di 50: 40,9 MB a visita).
       fetch() di suo chiede "qualsiasi tipo": l'Accept va dichiarato a mano, come fa il browser con <img> */
    var FOPT = { headers: { 'Accept': 'image/avif,image/webp,image/*;q=0.8,*/*;q=0.5' }, credentials: 'same-origin' };
    function cur() { return frameAt(shown) }
    function decode(i) {
      if (bmps[i] || decoding[i] || !blobs[i]) return;
      decoding[i] = 1; nDecoding++;
      function done(b) {
        delete decoding[i]; nDecoding--;
        if (b) { bmps[i] = b; if (Math.abs(i - cur()) <= 1.5) { lastF = -1; loop() } }
        pumpDecode();
      }
      if (window.createImageBitmap) createImageBitmap(blobs[i]).then(done, function () { done(null) });
      else {
        var im = new Image();
        im.onload = function () { (im.decode ? im.decode() : Promise.resolve()).then(function () { done(im) }, function () { done(im) }) };
        im.onerror = function () { done(null) };
        im.src = URL.createObjectURL(blobs[i]);
      }
    }
    function pumpDecode() {
      var c = Math.round(cur()), fwd = target >= shown;
      for (var d = 0; d <= RADIUS && nDecoding < 3; d++) {
        var ds = d ? (fwd ? [c + d, c - d] : [c - d, c + d]) : [c];
        for (var q = 0; q < ds.length && nDecoding < 3; q++) {
          var i = ds[q];
          if (i >= 0 && i < N && blobs[i] && !bmps[i] && !decoding[i]) decode(i);
        }
      }
      for (var j = 0; j < N; j++) { if (bmps[j] && Math.abs(j - c) > KEEP) { if (bmps[j].close) bmps[j].close(); bmps[j] = null } }
    }
    var order = [], seen = {};
    for (var i = 0; i <= RADIUS && i < N; i++) { seen[i] = 1; order.push(i) }
    for (var step = 16; step >= 1; step = step >> 1) { for (var k = 0; k < N; k += step) { if (!seen[k]) { seen[k] = 1; order.push(k) } } }
    var qi = 0, started = false;
    function pumpLoad() {
      while (active < 6 && qi < order.length) {
        (function (i) {
          active++;
          fetch(url(i), FOPT).then(function (r) { return r.ok ? r.blob() : null }).then(function (b) {
            active--; if (b) { blobs[i] = b; if (Math.abs(i - cur()) <= RADIUS) pumpDecode() } pumpLoad();
          }, function () { active--; pumpLoad() });
        })(order[qi++]);
      }
    }
    function blit(b, a) {
      var w = b.width, h = b.height, cw = cv.width, ch = cv.height, sc = Math.min(cw / w, ch / h);
      var dw = w * sc, dh = h * sc;
      ctx.globalAlpha = a; ctx.drawImage(b, (cw - dw) / 2, (ch - dh) / 2, dw, dh);
    }
    function nearestReady(i) { for (var d = 0; d <= RADIUS; d++) { if (i - d >= 0 && bmps[i - d]) return i - d; if (i + d < N && bmps[i + d]) return i + d } return -1 }
    function draw(f) {
      if (Math.abs(f - lastF) < 0.002) return true;
      var i0 = Math.max(0, Math.min(N - 1, Math.floor(f))), i1 = Math.min(N - 1, i0 + 1), t = f - i0;
      var exact = !!bmps[i0] && (t <= 0.01 || i1 === i0 || !!bmps[i1]);
      var a = bmps[i0] ? i0 : nearestReady(Math.round(f));
      if (a < 0) return false;
      ctx.globalCompositeOperation = 'source-over'; ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, cv.width, cv.height);
      if (a === i0 && t > 0.01 && i1 !== i0 && bmps[i1]) {
        ctx.globalCompositeOperation = 'lighter';
        blit(bmps[i0], 1 - t); blit(bmps[i1], t);
        ctx.globalCompositeOperation = 'source-over';
      } else blit(bmps[a], 1);
      ctx.globalAlpha = 1; drawn++;
      if (exact) lastF = f; else { lastF = -1; fallbacks++ }
      return exact;
    }
    function ease(x) { return x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2 }
    function progress() {
      var r = sec.getBoundingClientRect(), total = r.height - innerHeight;
      return Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
    }
    function setChapter(p) {
      var c = 0; for (var k = 0; k < CH.length; k++) if (p >= CH[k]) c = k;
      if (c === chap) return; chap = c;
      titles.forEach(function (h, k) { h.classList.toggle('on', k === c); h.classList.toggle('out', k < c) });
      descs.forEach(function (d, k) { d.classList.toggle('on', k === c) });
      if (cnt) cnt.textContent = ('0' + (c + 1)).slice(-2);
    }
    function tick() {
      running = false;
      var d = target - shown;
      shown = Math.abs(d) < 0.0004 ? target : shown + d * 0.14;
      var exact = draw(cur());
      if (rail) rail.style.width = (shown * 100).toFixed(2) + '%';
      setChapter(shown);
      pumpDecode();
      if (shown !== target || (!exact && (nDecoding || active))) loop();
    }
    function loop() { if (!running) { running = true; requestAnimationFrame(tick) } }
    function onScroll() { if (!visible) return; target = progress(); loop() }
    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.max(1, Math.round(cv.offsetWidth * dpr)), h = Math.max(1, Math.round(cv.offsetHeight * dpr));
      if (w === cv.width && h === cv.height) return;
      cv.width = w; cv.height = h; lastF = -1; draw(cur());
    }
    sec._film = { stato: function () { return { shown: shown, target: target, fotogramma: cur(), decodificati: bmps.filter(Boolean).length, scaricati: blobs.filter(Boolean).length, disegni: drawn, ripieghi: fallbacks } } };
    if (reduce) {
      sec.classList.add('static');
      titles.forEach(function (h) { h.classList.add('on') }); descs.forEach(function (d) { d.classList.add('on') });
      size();
      fetch(url(0), FOPT).then(function (r) { return r.blob() }).then(function (b) { blobs[0] = b; decode(0) });
      return;
    }
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (visible) { if (!started) { started = true; pumpLoad() } target = progress(); loop() }
    }, { rootMargin: '900px 0px' }).observe(sec);
    SC.addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', function () { size(); onScroll() });
    if (window.ResizeObserver) new ResizeObserver(size).observe(cv);
    setChapter(0); size();
  })();

  /* ---------- consenso cookie (27/09): banner nostro, piccolo; le scelte vanno a Shopify con la Customer Privacy API
     ufficiale (setTrackingConsent), così pixel e statistiche di Shopify si accendono solo dopo il sì, come col banner di Shopify.
     Compare solo dove Shopify chiede il consenso e finché il visitatore non ha scelto; "Preferenze cookie" nel piede lo riapre.
     In anteprima locale (niente Shopify) si vede con ?cookie=1. ---------- */
  (function () {
    if (!T.ckText) return;
    var api = null, box = null, veil = null, H = document.documentElement;
    function load(cb) {
      if (api) return cb(api);
      var S = window.Shopify;
      if (!S || !S.loadFeatures) return cb(null);
      S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        api = !err && S.customerPrivacy ? S.customerPrivacy : null; cb(api);
      });
    }
    function esc(x) { return String(x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c] }) }
    function row(k, name, desc, on) {
      return '<label class="ck-row"><span><b>' + esc(name) + '</b><small>' + esc(desc) + '</small></span>' +
        (k ? '<input type="checkbox" class="ck-sw" data-ck="' + k + '"' + (on ? ' checked' : '') + '>' : '<em>' + esc(T.ckAlways) + '</em>') + '</label>';
    }
    function build() {
      if (box) return;
      var c = api ? api.currentVisitorConsent() || {} : {};
      box = document.createElement('section');
      box.className = 'ck'; box.setAttribute('role', 'dialog'); box.setAttribute('aria-live', 'polite'); box.setAttribute('aria-label', 'Cookie');
      box.setAttribute('aria-modal', 'true');
      box.innerHTML = (T.ckTitle ? '<p class="ck-h">' + esc(T.ckTitle) + '</p>' : '') + '<p class="ck-t">' + esc(T.ckText) + ' <a href="' + esc(T.ckUrl) + '">' + esc(T.ckPolicy) + '</a> · <a href="' + esc(T.ckShopifyUrl) + '" target="_blank" rel="noopener">' + esc(T.ckShopify) + '</a></p>' +
        '<div class="ck-p" hidden>' + row('', T.ckNec, T.ckNecD) + row('analytics', T.ckAna, T.ckAnaD, c.analytics === 'yes') +
        row('marketing', T.ckMkt, T.ckMktD, c.marketing === 'yes') + row('preferences', T.ckPref, T.ckPrefD, c.preferences === 'yes') + '</div>' +
        '<div class="ck-b"><button type="button" class="ck-no">' + esc(T.ckReject) + '</button><button type="button" class="ck-yes">' + esc(T.ckAccept) + '</button>' +
        '<button type="button" class="ck-set">' + esc(T.ckPrefs) + '</button><button type="button" class="ck-save" hidden>' + esc(T.ckSave) + '</button></div>';
      /* 03/10 (Danilo, punto 5 "importantissimo"): riquadro al centro su un velo scuro; la pagina resta ferma finché non si sceglie.
         "Rifiuta" ha la stessa grandezza di "Accetta" (come chiede la legge tedesca); così quasi tutti rispondono e Meta e Shopify vedono le visite */
      veil = document.createElement('div'); veil.className = 'ck-veil'; veil.setAttribute('aria-hidden', 'true');
      document.body.appendChild(veil);
      document.body.appendChild(box);
      box.querySelector('.ck-yes').onclick = function () { send(true, true, true) };
      box.querySelector('.ck-no').onclick = function () { send(false, false, false) };
      box.querySelector('.ck-set').onclick = function () { prefs(true) };
      box.querySelector('.ck-save').onclick = function () {
        function v(k) { return box.querySelector('[data-ck="' + k + '"]').checked }
        send(v('analytics'), v('marketing'), v('preferences'));
      };
    }
    function prefs(on) {
      box.querySelector('.ck-p').hidden = !on; box.querySelector('.ck-save').hidden = !on; box.querySelector('.ck-set').hidden = on;
      box.classList.toggle('ck--open', on);
    }
    function show(open) {
      build(); prefs(!!open); H.classList.add('ck-on', 'ck-modal', 'lock');
      requestAnimationFrame(function () { requestAnimationFrame(function () { box.classList.add('in'); veil.classList.add('in') }) });
    }
    function hide() {
      if (!box) return; box.classList.remove('in'); if (veil) veil.classList.remove('in');
      H.classList.remove('ck-on', 'ck-modal');
      /* lo sblocco dello scorrimento solo se non è aperto il menu (che usa lo stesso blocco) */
      var dr = document.getElementById('drawer'); if (!(dr && dr.classList.contains('open'))) H.classList.remove('lock');
      setTimeout(function () { if (box) { box.remove(); box = null } if (veil) { veil.remove(); veil = null } }, 380);
    }
    function send(a, m, p) {
      if (api) try { api.setTrackingConsent({ analytics: a, marketing: m, preferences: p, sale_of_data: m }, function () {}) } catch (e) {}
      hide();
    }
    /* finché il banner di Shopify è ancora acceso (prima di spegnerlo dall'admin) non ne mostriamo due */
    function shopifyBanner() { return !!document.getElementById('shopify-pc__banner') }
    load(function (a) {
      if (a) {
        var c = a.currentVisitorConsent() || {}, chosen = c.analytics || c.marketing || c.preferences;
        /* UE, SEE, Regno Unito e Svizzera sempre: senza il banner di Shopify le sue aree automatiche si spengono */
        var reg = String((a.getRegion && a.getRegion()) || window.SY_COUNTRY || '').slice(0, 2).toUpperCase();
        var ue = /^(AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE|IS|LI|NO|GB|CH)$/.test(reg);
        if (!chosen && (ue || a.shouldShowBanner())) setTimeout(function () { if (!shopifyBanner()) show(false) }, 700);
      } else if (/[?&]cookie=1/.test(location.search)) show(false);
    });
    document.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-ck-open]'); if (!o) return;
      e.preventDefault(); load(function () { if (box) prefs(true); else show(true) });
    });
  })();

  render();
  /* scheda prodotto: la galleria parte dalla foto della taglia scelta (Coppia, o ?variant=) */
  if (P.length && $('.gal-track')) { var p0 = prod(); if (p0.img) gallery(p0.img, true) }
  count();
})();
